(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.wbdCarousel = {
    attach: function (context, settings) {
      const sliderSelector = '.wbdc__carousel_slider-for';
      const navSelector = '.wbdc__carousel_slider-nav';
      $('.wbd-component-carousel').each(function (e) {
        $(this).find(sliderSelector).slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          swipe: false,
          fade: true,
          asNavFor: $(this).find(navSelector)
        });
        $(this).find(navSelector).slick({
          infinite: true,
          slidesToShow: 5,
          slidesToScroll: 1,
          swipe: false,
          asNavFor: $(this).find(sliderSelector),
          dots: false,
          centerMode: false,
          focusOnSelect: true,
          centerPadding: '40px',
          variableWidth: true
        });
      })
    }
  };
})(jQuery, Drupal, once);
